import React from "react";
import { Modal, Button } from "react-bootstrap";

interface Props {
  show: boolean;
  text: string;
  type: "success" | "error" | "warning" | "info";
  onClose: () => void;
}

export default class UniversalNotificationModal extends React.Component<Props> {
  render() {
    const { show, text, type, onClose } = this.props;

    // Mesajı noktalı virgüle göre ayırıyoruz
    const lines = text
      .split("\n")
      .map(l => l.trim())
      .filter(l => l.length > 0);

    // Başlık rengi ve simgesi
    const headerBg = {
      success: "success",
      error: "danger",
      warning: "warning",
      info: "primary"
    }[type];

    const headerText = {
      success: "Başarılı",
      error: "Hata",
      warning: "Uyarı",
      info: "Bilgi"
    }[type];

    return (
      <Modal
        show={show}
        onHide={onClose}
        centered
        backdrop="static" // tıklayınca kapanmasın
        keyboard={true}   // esc ile kapanabilir
      >
        <Modal.Header closeButton className={`bg-${headerBg} text-white`}>
          <Modal.Title>{headerText}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ fontSize: "15px" }}>
          {lines.map((line, index) => (
            <div key={index} style={{ marginBottom: "6px" }}>
              • {line}
            </div>
          ))}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onClose}>
            Kapat
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}
